<template>
  <div style="width: 100%;height: 100%;padding: 20px;box-sizing: border-box;background-color: white">
    <div style="height: 50px">
      <el-input v-model="searchName" placeholder="服务包名称搜索" clearable style="width: 180px"
                @keyup.enter.native="searchQuery"></el-input>
      <el-select v-fixZoom v-model="searchStatus" placeholder="状态筛选" clearable style="width: 120px;margin-left: 8px">
        <el-option label="全部" :value="0"></el-option>
        <el-option label="生效" :value="1"></el-option>
        <el-option label="暂停" :value="2"></el-option>
        <el-option label="结束" :value="3"></el-option>
      </el-select>
      <el-button type="primary" @click="searchQuery" style="margin-left: 8px">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="addPackage" style="margin-left: 8px">新建服务包</el-button>
    </div>
    <div style="height: calc(100% - 100px)">
      <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。"
                :data="tableData" border style="width: 100%" highlight-current-row ref="singleTable">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column label="服务包名称" min-width="120" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属组织" min-width="110" align="center">
          <template slot-scope="scope">
            <span>{{ getOrgName(scope.row.oid) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务内容" min-width="110" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.supplier_type_name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="服务提供商" min-width="110" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.supplier_name || '待分配' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="总次数" width="80" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.total_count }}次</span>
          </template>
        </el-table-column>
        <el-table-column label="间隔月数" width="90" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.interval_months }}月</span>
          </template>
        </el-table-column>
        <el-table-column label="服务时刻" min-width="140" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.begin_hour }} ~ {{ scope.row.end_hour }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="75" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_active === 1" type="success" size="mini">生效</el-tag>
            <el-tag v-else-if="scope.row.is_active === 2" type="warning" size="mini">暂停</el-tag>
            <el-tag v-else-if="scope.row.is_active === 3" type="info" size="mini">结束</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="关联老人数" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.person_count || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_tm" label="创建时间" min-width="150" align="center"></el-table-column>
        <el-table-column align="center" label="操作" width="280">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="viewPersons(scope.row)">查看老人</el-button>
            <el-button size="mini" type="warning" @click="editPackage(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deletePackage(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage" :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
      </el-pagination>
    </div>

    <!-- 新建/编辑服务包 -->
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="700px"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div><strong>{{ addEditTitle }}</strong></div>
        <div class="line-title"></div>
      </div>
      <add-edit-package :addEdit="addEditObj" v-model="addEditShow" @refresh="searchQuery"></add-edit-package>
    </el-dialog>

    <!-- 查看关联老人 -->
    <el-dialog :visible.sync="personsShow" v-if="personsShow" width="900px"
               :show-close="true" :close-on-click-modal="true" center class="all-open">
      <div class="title-top-alarm">
        <div><strong>关联老人 — {{ currentPackage.name }}</strong></div>
        <div class="line-title"></div>
      </div>
      <service-package-persons :packageRow="currentPackage" v-model="personsShow"></service-package-persons>
    </el-dialog>
  </div>
</template>

<script>
import { queryorg } from '../../api/organizer'
import {
  querypersonservicepackage,
  deletepersonservicepackage
} from '../../api/serviceMark'
import addEditPackage from './childComponents/addEditServicePackage.vue'
import servicePackagePersons from './childComponents/servicePackagePersons.vue'

export default {
  name: 'servicePackage',
  components: { addEditPackage, servicePackagePersons },
  data () {
    return {
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      searchName: '',
      searchStatus: 0,
      orgData: [],
      addEditShow: false,
      addEditTitle: '新建服务包',
      addEditObj: {
        isAdd: true,
        row: {}
      },
      personsShow: false,
      currentPackage: {}
    }
  },
  created () {
    this.loadBasicData()
  },
  methods: {
    loadBasicData () {
      this.loading = true
      queryorg().then(res => {
        this.orgData = res.data.org || []
        this.loadTableData()
      }).catch(() => {
        this.loading = false
      })
    },
    loadTableData () {
      this.loading = true
      let params = { page: this.currentPage, size: this.pageSize }
      let data = { name: this.searchName, is_active: this.searchStatus, oid: 0 }
      querypersonservicepackage(params, data).then(res => {
        this.tableData = res.data.list || []
        this.totalCells = res.data.cnt || 0
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    searchQuery () {
      this.currentPage = 1
      this.loadTableData()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.loadTableData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.loadTableData()
    },
    getOrgName (oid) {
      let org = this.orgData.find(o => o.id === oid)
      return org ? org.name : ''
    },
    addPackage () {
      this.addEditTitle = '新建服务包'
      this.addEditObj.isAdd = true
      this.addEditObj.row = {}
      this.addEditShow = true
    },
    editPackage (row) {
      this.addEditTitle = '编辑服务包'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    deletePackage (row) {
      this.$confirm(`此操作将删除服务包【${row.name}】，是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deletepersonservicepackage({ id: row.id }).then(() => {
          this.$notify({ title: '成功', message: '删除服务包成功', type: 'success', duration: 2000 })
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.loadTableData()
        }).catch(() => {})
      }).catch(() => {})
    },
    viewPersons (row) {
      this.currentPackage = row
      this.personsShow = true
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/servicePackage.vue